import React, { useContext } from 'react';
import classnames from 'classnames';

import { useWindowStore, useConfigStore, useMapStateStore } from '../../../../stores';
import SiteSeeContext from '../../../SiteSeeGuides/SiteSeeContext';
import { getPulseTarget, PULSE_TARGETS } from '../../../SiteSeeGuides/SiteSeeGuideData';

import MapControlsZoomLessIcon from './MapControlsZoomLessIcon';
import { ReactComponent as MobileMapControlsZoomLessIcon } from './MobileMapControlsZoomLessIcon.svg';

const MapControlsZoomLess = () => {
  const isMobile = useWindowStore((state) => state.isMobile);
  const mapConfig = useConfigStore((state) => state.mapConfig);
  const activeZoom = useMapStateStore((state) => state.activeZoom);
  const setActiveZoom = useMapStateStore((state) => state.setActiveZoom);

  const { siteSeeGuideId, siteSeeGuideMode } = useContext(SiteSeeContext);
  const isPulsing = isMobile && siteSeeGuideMode === 'tour' && getPulseTarget(siteSeeGuideId, isMobile) === PULSE_TARGETS.ZOOM_OUT;

  // Round activeZoom since Google Maps can return fractional values during zoom animations.
  const minZoom = mapConfig?.googleMapsConfig?.zooms?.min;
  const disabled = activeZoom != null && minZoom && Math.round( activeZoom ) <= minZoom;

  const zoomLess = (e) => {
    e.preventDefault();
    // Blur button to prevent browser scroll-to-focus behavior
    e.currentTarget.blur();
    // Use current zoom from store, or fallback to a reasonable default
    const currentZoom = activeZoom ?? 18;
    const newZoom = currentZoom - 1;
    setActiveZoom(newZoom);
  };

  return minZoom ? (
    <button
      id="mapControlsZoomLess"
      type="button"
      disabled={disabled}
      className={
        classnames( {
          mapControl: !isMobile,
          mobileMapControl: isMobile,
          'mapControl--disabled': !isMobile && disabled,
          'mobileMapControl--disabled': isMobile && disabled,
          'mobileMapControl--pulsing': isPulsing,
        } )
      }
      onClick={zoomLess}
    >
      {isMobile ? <MobileMapControlsZoomLessIcon className="mobileMapControl__svg" /> : <MapControlsZoomLessIcon /> }
    </button>
  ) : <></>;
};

export default MapControlsZoomLess;
